import { useRouter } from "next/router";
import { useState, useRef, useEffect } from "react";
import {
  SITEMAP_PAGE_VIEW,
  SITE_MAP_VIEW_SELECTED,
  SITE_MAP_MODULE,
} from "@/constants/amplitude";
import {
  SITEMAP_MENU_OPTIONS,
  SITEMAP_AVAILABLE_TIMES,
} from "@/constants/sitemap";
import { useAmplitude } from "./useAmplitude";

const urlMap = SITEMAP_MENU_OPTIONS.reduce(
  (prev, next, index) => ({
    ...prev,
    [next]: SITEMAP_AVAILABLE_TIMES[index] ?? "",
  }),
  {} as Record<string, string>
);
const valueMap = Object.fromEntries(
  Object.entries(urlMap).map(([k, v]) => [v, k])
);
export default function useSitemapNav(menuPath: string) {
  const menuItem =
    Object.keys(urlMap).find((key) => urlMap[key] === menuPath) ?? "All Years";
  const [selected, setSelected] = useState(menuItem);
  const router = useRouter();
  const { logAmplitudeEvent, setPage } = useAmplitude();
  const pageLoadRef = useRef(false);
  useEffect(() => {
    if (!pageLoadRef.current) {
      setPage("sitemap");
      logAmplitudeEvent(SITEMAP_PAGE_VIEW);
    }
    pageLoadRef.current = true;
  }, [logAmplitudeEvent, setPage]);

  const [mobileOption, setMobileOption] = useState(
    menuPath === "All Years" ? "" : menuPath
  );

  const mobileSelect = (value: string) => {
    logAmplitudeEvent(SITE_MAP_VIEW_SELECTED, {
      Module: SITE_MAP_MODULE,
      "Item Selected": valueMap[value],
    });
    router.push(value);
    setMobileOption(value);
  };
  const tabSelect = (value: string) => {
    logAmplitudeEvent(SITE_MAP_VIEW_SELECTED, {
      Module: SITE_MAP_MODULE,
      "Item Selected": value,
    });

    router.push("/sitemap/" + urlMap[value]);
    setSelected(value);
  };
  return {
    mobileOption,
    mobileSelect,
    selected,
    tabSelect,
    menuItem,
    logAmplitudeEvent,
  };
}
